"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTest = exports.isStorybook = exports.isProduction = exports.isDevelopment = exports.getFigmaAccessToken = void 0;
/* eslint-disable no-restricted-globals */

function isEnv(env) {
  var _process, _process$env;
  return Boolean(typeof process === 'object' && ((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === env);
}
const isDevelopment = () => {
  return isEnv('development');
};
exports.isDevelopment = isDevelopment;
const isProduction = () => {
  return isEnv('production');
};
exports.isProduction = isProduction;
const isTest = () => {
  return isEnv('test');
};
exports.isTest = isTest;
const isStorybook = () => {
  var _process2, _process2$env;
  return Boolean(typeof process === 'object' && ((_process2 = process) === null || _process2 === void 0 ? void 0 : (_process2$env = _process2.env) === null || _process2$env === void 0 ? void 0 : _process2$env.STORYBOOK_SKIP_ANIMATION)) ||
  // @ts-expect-error STORYBOOK_SKIP_ANIMATION is injected with DefinePulgin as a global var
  typeof STORYBOOK_SKIP_ANIMATION !== 'undefined';
};
exports.isStorybook = isStorybook;
const getFigmaAccessToken = () => {
  var _process$env$FIGMA_AC;
  // @ts-expect-error FIGMA_ACCESS_TOKEN is included globally with DefinePlugin
  return typeof FIGMA_ACCESS_TOKEN !== 'undefined' ?
  // @ts-expect-error FIGMA_ACCESS_TOKEN is included globally with DefinePlugin
  FIGMA_ACCESS_TOKEN : (_process$env$FIGMA_AC = process.env.FIGMA_ACCESS_TOKEN) !== null && _process$env$FIGMA_AC !== void 0 ? _process$env$FIGMA_AC : '';
};
exports.getFigmaAccessToken = getFigmaAccessToken;